import React, { useCallback, useMemo } from "react";
import { Controller } from "react-hook-form";
import FloatingInput from "../../../components/input/FloatingInput";

const OwnerTab = React.memo(({
  control,
  ownerCountyAutocomplete,
  ownerState,
  updateOwnerField,
  handleSearchOwner,
}) => {
  const handleFirstNameChange = useCallback((e) => {
    updateOwnerField("firstName", e.target.value);
  }, [updateOwnerField]);

  const handleLastNameChange = useCallback((e) => {
    updateOwnerField("lastName", e.target.value);
  }, [updateOwnerField]);

  const handleSearchEntireStateChange = useCallback((e) => {
    updateOwnerField("searchEntireState", e.target.checked);
  }, [updateOwnerField]);

  const handleOwnerSearch = useCallback(() => {
    console.log('🔍 [OwnerTab] Owner search initiated');
   // console.log('👤 [OwnerTab] First name:', ownerState.firstName);
   // console.log('👤 [OwnerTab] Last name:', ownerState.lastName);
   // console.log('📍 [OwnerTab] Selected county:', ownerCountyAutocomplete.selectedCounty);
   // console.log('🌍 [OwnerTab] Search entire state:', ownerState.searchEntireState);

    handleSearchOwner(
      ownerState.firstName,
      ownerState.lastName,
      ownerCountyAutocomplete.selectedCounty,
      ownerState.searchEntireState
    );
   // console.log('✅ [OwnerTab] Owner search handler called');
  }, [handleSearchOwner, ownerState, ownerCountyAutocomplete.selectedCounty]);

  // Check if form has valid data to show submit button
  const shouldShowSubmitButton = useMemo(() => {
    const hasName = ownerState.firstName.trim() || ownerState.lastName.trim();
    const hasLocation = ownerState.searchEntireState || ownerCountyAutocomplete.selectedCounty;
    return hasName && hasLocation;
  }, [ownerState.firstName, ownerState.lastName, ownerState.searchEntireState, ownerCountyAutocomplete.selectedCounty]);

  return (
    <div>
      <div className="frm-field-2">
        <div className="form-group input-sticky">
          <FloatingInput
            label="First Name or Company Name"
            value={ownerState.firstName}
            onChange={handleFirstNameChange}
            placeholder="Enter first name or company name"
          />
        </div>
        <div className="form-group input-sticky">
          <FloatingInput
            label="Last Name"
            value={ownerState.lastName}
            onChange={handleLastNameChange}
            placeholder="Enter last name"
          />
        </div>
      </div>

      {/* County autocomplete */}
      <div className="frm-field-2">
        <div className="form-group input-sticky relative droparrow">
          <FloatingInput
            type="search"
            label="County"
            placeholder="Enter county name"
            value={ownerCountyAutocomplete.query}
            onChange={ownerCountyAutocomplete.onChange}
            onBlur={ownerCountyAutocomplete.onBlur}
            onKeyDown={ownerCountyAutocomplete.onKeyDown}
          />
          {/* County suggestions dropdown */}
          {ownerCountyAutocomplete.suggestions.length > 0 && (
            <div className="search-list-prop county-suggestions">
              {ownerCountyAutocomplete.suggestions.map((s, idx) => (
                <div
                  key={s.code}
                  ref={(el) => (ownerCountyAutocomplete.suggestionItemRefs.current[idx] = el)}
                  className={`search-list-prop-wrap ${idx === ownerCountyAutocomplete.activeIndex ? "active" : ""}`}
                  onMouseEnter={() => ownerCountyAutocomplete.setActiveIndex(idx)}
                  onMouseDown={(e) => {
                    e.preventDefault();
                    ownerCountyAutocomplete.selectSuggestion(s);
                  }}
                  onTouchStart={(e) => {
                    e.preventDefault();
                    ownerCountyAutocomplete.selectSuggestion(s);
                  }}
                >
                  <div className="search-list-prop-heading">
                    {s.displayText}
                  </div>
                  <div className="search-list-prop-desc">
                    {s.code}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="form-group">
          <Controller
            name="entireState"
            control={control}
            render={({ field }) => (
              <p className="inlineboth">
                <input
                  type="checkbox"
                  checked={ownerState.searchEntireState}
                  onChange={handleSearchEntireStateChange}
                />
                <span>
                  Search Entire State
                </span>
              </p>
            )}
          />
          
        </div>
      </div>


      {/* Address Search Button */}
      {shouldShowSubmitButton && (
        <div className="frm-field-1 slide-down">
          <div className="form-group text-right">
            <button
              type="button"
              className="submit-btn btn-bg inpt-btn sht-btn ch-btnsave-new"
              onClick={handleOwnerSearch}
              disabled={ownerState.isSearching}
            >
              {ownerState.isSearching ? "Searching..." : "Search Owner"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
});

OwnerTab.displayName = "OwnerTab";

export default OwnerTab;